/*eslint-disable*/
import React, { useState, useEffect, useImperativeHandle } from "react";
import {
  Grid,
  Typography,
  TextField,
  MenuItem,
  Divider,
  FormControl,
  InputLabel,
  Paper,
  Box
} from "@mui/material";
import { STYLES } from "config";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";

function PropertyInformation(props) {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setstate(data);
  }, [data]);

  const validateField = (name, value) => {
    let error = '';

    if (name === 'grossmonthlyRental' && !value) {
      error = 'Gross Monthly Rental is required';
    } else if ((name === 'retailPrice' || name === 'rentalPrice') && (!value || isNaN(value))) {
      error = 'Valid number is required';
    }

    setErrors(prev => ({ ...prev, [name]: error }));
    return !error;
  };

  useImperativeHandle(props.ref, () => ({
    isValidated() {
      const floorSize = state?.floorSize;
      let isValid = true;

      const newErrors = {};

      if (!floorSize || floorSize === "") {
        newErrors.floorSize = "floor size is required";
        isValid = false;
      }

      setErrors(newErrors);
      return isValid;
    }
  }));

  const updateData = (e) => {
    const { name, value } = e.target;
    const isValid = validateField(name, value);

    if (isValid) {
      const updatedState = { ...state, [name]: value };
      setstate(updatedState);
      setvalue(updatedState);
    }
  };

  const inputStyle = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: "#003366",
      },
      '&:hover fieldset': {
        borderColor: "#003366",
      },
    },
  };

  return (
    <Paper elevation={5} sx={{ p: 3 }}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h5" gutterBottom sx={{ color: STYLES.WEB_APP_FONT_CLR }}>
          Property Information
        </Typography>
        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Typography variant="body1" paragraph sx={{ color: STYLES.WEB_APP_FONT_CLR }}>
          The key property details should be captured here.
        </Typography>

        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          {/* Date Added */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Date Added
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              disabled
              value={new Date(state?.CreatedAt).toLocaleDateString()}
              sx={inputStyle}
            />
          </Grid>

          {/* Retail Price */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Retail Price
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="retailPrice"
              value={state?.retailPrice || ''}
              onChange={updateData}
              error={!!errors.retailPrice}
              helperText={errors.retailPrice}
              sx={inputStyle}
            />
          </Grid>

          {/* Extras */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Extras
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="extrasInfor"
              value={state?.extrasInfor || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Land Size */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Land Size
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="landSize"
              value={state?.landSize || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Floor Size */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Floor Size<span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="floorSize"
              value={state?.floorSize || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Building Height */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Building Height
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="buildingHeight"
              value={state?.buildingHeight || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Floor Loading Capacity */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Floor Loading Capacity
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="floorLoadingCapacity"
              value={state?.floorLoadingCapacity || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Office Space Size */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Office Space Size
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="officeSize"
              value={`${state?.officeSize}` || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Office Space Price */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Office Space Price
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="officeSpacePriceSqm"
              value={state?.officeSpacePriceSqm || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Office Space Total Cost */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Office Space Total Cost
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="officeSpaceTotalCost"
              value={state?.officeSpaceTotalCost || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Retail Size */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Retail Size
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="retailSize"
              value={state?.retailSize || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Rental Price */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Rental Price
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="rentalPrice"
              value={state?.rentalPrice || ''}
              onChange={updateData}
              error={!!errors.rentalPrice}
              helperText={errors.rentalPrice}
              sx={inputStyle}
            />
          </Grid>

          {/* Retail Total Cost */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Retail Total Cost
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="retailTotalCost"
              value={state?.retailTotalCost || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Factory Warehouse Size */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Factory Warehouse Size
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="warehouseSize"
              value={state?.factoryWarehouseSize || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Factory Warehouse Price */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Factory Warehouse Price
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="factoryWarehousePrice"
              value={state?.factoryWarehousePrice || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Factory Warehouse Total Cost */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Factory Warehouse Total Cost
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="factoryWarehouseTotalCost"
              value={state?.factoryWarehouseTotalCost || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Yard Size */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Yard Size
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="yardSize"
              value={state?.yardSize || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Yard Price */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Yard Price
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="yardPrice"
              value={state?.yardPrice || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Yard Total Cost */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Yard Total Cost
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="yardTotalCost"
              value={state?.yardTotalCost || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Property Size Total Cost */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Property Size Total Cost
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="propertySizeTotalCost"
              value={state?.propertySizeTotalCost || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Municipal Value */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Municipal Value
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              size="small"
              name="municipalValue"
              value={state?.municipalValue || ''}
              onChange={updateData}
              sx={inputStyle}
            />
          </Grid>

          {/* Gross Monthly Rental */}
          {/* <Grid item size={2}>
          <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
            Gross Monthly Rental *
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            size="small"
            required
            name="grossmonthlyRental"
            value={state?.grossmonthlyRental || ''}
            onChange={updateData}
            error={!!errors.grossmonthlyRental}
            helperText={errors.grossmonthlyRental}
            sx={inputStyle}
          />
        </Grid> */}
        </Grid>
      </Box>
    </Paper>
  );
}

export default PropertyInformation;